import { IScheduleActivityMajorMilestone } from '../../interfaces/ischedule-activity-major-milestone';
import { MajorMilestone } from '../major-milestone';
import { ScheduleActivity } from '../schedule-activity';

export class ScheduleActivityMajorMilestoneBase {
  ScheduleActivityMajorMilestoneId: number;
  MajorMilestoneId: number | null;
  ScheduleActivityId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  MajorMilestone?: MajorMilestone;
  ScheduleActivity?: ScheduleActivity;

  constructor(item?: IScheduleActivityMajorMilestone) {
    if (item) {

      this.ScheduleActivityMajorMilestoneId = item.ScheduleActivityMajorMilestoneId;
      this.MajorMilestoneId = item.MajorMilestoneId;
      this.ScheduleActivityId = item.ScheduleActivityId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.MajorMilestone = new MajorMilestone(item.MajorMilestone);
      this.ScheduleActivity = new ScheduleActivity(item.ScheduleActivity);
    }
  }
}